import React, { useState } from 'react';
import LoadingOverlayWrapper from 'react-loading-overlay-ts';
import { ToastContainer } from 'react-toastify';
import { ThemeProvider } from 'styled-components';
import 'react-toastify/dist/ReactToastify.css';

import { GlobalStyles } from './styles/GlobalStyles';
import { theme } from './styles/theme';

import RouterComponent from './components/RouterComponent';
import Context, { IContext, IEmpresa } from './context/Context';
import { IAtalhos } from './types/Atalhos';

window.document.title = 'TI.Fire Sistemas';

function App() {
  const [isLoadingOverlay, setIsLoadingOverlay] = useState<boolean>(false);
  const [dadosUsuario, setDadosUsuario] = useState<any>(null);
  const [atalhos, setAtalhos] = useState<IAtalhos>();
  const [empresa, setEmpresa] = useState<IEmpresa>();

  const contextValues: IContext = {
    empresa, setEmpresa,
    isLoadingOverlay, setIsLoadingOverlay,
    dadosUsuario, setDadosUsuario,
    atalhos, setAtalhos
  }

  return (
    <ThemeProvider theme={theme}>
      <Context.Provider value={contextValues}>
        <GlobalStyles />
        <ToastContainer
          style={{ zIndex: 999999999999 }}
          position='top-right'
          theme='colored'
        />
        <LoadingOverlayWrapper
          active={isLoadingOverlay}
          spinner
          text='Aguarde...'
          styles={{
            wrapper: (base) => ({ ...base, height: '100%' }),
            // Fixo na tela: cobre o conteúdo mesmo com o scroll da página
            overlay: (base) => ({
              ...base,
              position: 'fixed',
              zIndex: 1000,
              backgroundColor: theme.cores.overlay
            })
          }}
        >
          <RouterComponent />
        </LoadingOverlayWrapper>
      </Context.Provider>
    </ThemeProvider>
  )
}

export default App;
